export default {"src":"/_next/static/media/cd.f03d3b0d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};